import template from '@components/expertise/discovery/discovery.module.scss'
import { ImageTextBlock } from '@components/shared/blocks/image-text-block';
import Image from 'next/image';
import { IDiscoveryPhaseSection } from '../../discovery.state';
import style from './index.module.scss'

interface IDiscoveryPhaseSectionProps {
    section: IDiscoveryPhaseSection;
}

const DiscoveryPhaseSectionComponent = ({ section }: IDiscoveryPhaseSectionProps) => {
    return (
        <section className={`${template.section} ${template.section__block_gray}`}>
            <div className={`${template.container} ${style.block}`}>
                <ImageTextBlock title={section.title} text={section.text} imageSrc={section.imgSrc}/>
            </div>
        </section>
    )
}

export default DiscoveryPhaseSectionComponent;